var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.plot.ChildrenPlots.length == 0
        ? [_c("PlotHeaderEntry", { attrs: { plot: _vm.plot, pad: "" } })]
        : [
            _c(
              "v-list-group",
              {
                attrs: { value: "false" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function () {
                      return [
                        _c("PlotHeaderEntry", { attrs: { plot: _vm.plot } }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(" "),
                _vm._l(_vm.plot.ChildrenPlots, function (childPlot) {
                  return _c("PlotHeaderEntry", {
                    key: childPlot.Id,
                    attrs: {
                      plot: childPlot,
                      pad: childPlot.ChildrenPlots.length == 0,
                    },
                  })
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }